import {
  AUTH_REQUEST,
  AUTH_ERROR,
  AUTH_RENEW,
  AUTH_SUCCESS,
  AUTH_LOGOUT,
  ONLINE,
  OFFLINE
} from "../actions/auth";
import {
  USER_REQUEST
} from "../actions/user";
import {
  logInWithPassword,
  renewToken
} from "@/api";
import axios from "axios";
const moment = require("moment");

const state = {
  accessToken: localStorage.getItem("access-token") || "",
  refreshToken: localStorage.getItem("refresh-token") || "",
  tokensExpiry: localStorage.getItem("tokens-expiry"),
  status: "",
  online: false,
  hasLoadedOnce: false
};

const getters = {
  isAuthenticated: state => !!state.accessToken,
  authStatus: state => state.status,
  isRefreshTokenValid: state => moment(state.tokensExpiry).isAfter(moment()),
  isOnline: state => state.online
};

const actions = {
  [AUTH_REQUEST]: ({
    commit,
    dispatch
  }, loginInfo) => {
    return new Promise((resolve, reject) => {
      // The Promise used for router redirect in login
      commit(AUTH_REQUEST);
      logInWithPassword(loginInfo)
        .then(resp => {
          dispatch(AUTH_SUCCESS, resp.data);
          dispatch(USER_REQUEST);
          resolve(resp);
        })
        .catch(err => {
          commit(AUTH_ERROR, err);
          reject(err);
        });
    });
  },

  [AUTH_SUCCESS]: ({
    commit,
    dispatch
  }, tokenData) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_SUCCESS, tokenData);
      // On auth success, get token expiry and schedule a token refresh before access token expires.
      // Generate random additional seconds (up to 30 in this case) to append to the expiration time 
      // to ensure multiple clients dont schedule simultaneous refresh.
      const jitter = Math.floor(Math.random() * 30)
      const timeout = tokenData.expires_in - jitter;
      setTimeout(() => {
        dispatch(AUTH_RENEW);
      }, timeout * 1000);
      resolve();
    });
  },

  [AUTH_LOGOUT]: ({
    commit,
    dispatch
  }) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_LOGOUT);
      resolve();
    });
  },

  [AUTH_RENEW]: ({
    commit,
    dispatch
  }) => {
    return new Promise((resolve, reject) => {
      if (state.refreshToken && getters.isRefreshTokenValid) {
        renewToken(state.refreshToken)
          .then(resp => {
            dispatch(AUTH_SUCCESS, resp.data);
            resolve(resp);
          })
          .catch(err => {
            commit(AUTH_ERROR, err);
            dispatch(AUTH_LOGOUT);
            reject(err);
          });
      } else {
        dispatch(AUTH_LOGOUT);
      }
    });
  }
};

// basic mutations, showing loading, success, error to reflect the api call status and the token when loaded
const mutations = {
  [ONLINE]: state => {
    state.online = true;
  },
  [OFFLINE]: state => {
    state.online = false;
  },

  [AUTH_REQUEST]: state => {
    state.status = "loading";
  },

  [AUTH_SUCCESS]: (state, tokenData) => {
    const accessToken = tokenData.access_token;
    const refreshToken = tokenData.refresh_token;
    const now = moment();
    const tokensExpiry = now.add(23, 'hours').toISOString();

    // Update state
    state.status = "success";
    state.accessToken = accessToken;
    state.refreshToken = refreshToken;
    state.tokensExpiry = tokensExpiry;
    state.hasLoadedOnce = true;

    // Save the tokens in local storage.
    localStorage.setItem("access-token", accessToken);
    localStorage.setItem("refresh-token", refreshToken);
    localStorage.setItem("tokens-expiry", tokensExpiry);

    // Here set the header of your ajax library to the token value.
    axios.defaults.headers.common["Authorization"] = "bearer " + accessToken;
  },

  [AUTH_ERROR]: state => {
    state.status = "error";
    state.hasLoadedOnce = true;
    // if the request fails, remove any possible user token if possible
    localStorage.removeItem("access-token");
    localStorage.removeItem("refresh-token");
    localStorage.removeItem("tokens-expiry");
  },

  [AUTH_LOGOUT]: state => {
    state.accessToken = "";
    state.refreshToken = "";
    state.status = "";
    state.tokensExpiry = moment().toISOString();
    localStorage.removeItem("access-token");
    localStorage.removeItem("refresh-token");
    localStorage.removeItem("tokens-expiry");
    // remove the axios default header
    delete axios.defaults.headers.common["Authorization"];
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};